import { render } from "./TabBodyRGBProducts.vue?vue&type=template&id=58272e25&scoped=true"
import script from "./TabBodyRGBProducts.vue?vue&type=script&lang=js"
export * from "./TabBodyRGBProducts.vue?vue&type=script&lang=js"

import "./TabBodyRGBProducts.vue?vue&type=style&index=0&id=58272e25&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58272e25"]])

export default __exports__